module.exports = __webpack_public_path__ + "img/supaiapp_ercode.c990cacd.png";